import Notice, { NoticeType, NoticeResponse } from './Notice';

export default class Dialog extends Notice {
	type = NoticeType.DIALOG;
	title = ''; // for dialogs
	declineLabel = '';

	constructor(title: string, message: string, accept = 'OK') {
		super();
		this.title = title;
		this.message = message;
		this.acceptLabel = accept;
	}

	setDeclineLabel(label: string): this {
		this.declineLabel = label;
		return this;
	}

	decline(): void {
		this.resolve(NoticeResponse.DECLINE);
	}
}